import { render } from "./ServiceLandingPage.vue?vue&type=template&id=3b544c0f"
import script from "./ServiceLandingPage.vue?vue&type=script&lang=js"
export * from "./ServiceLandingPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Sveve\\www\\vue\\sveve.no\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__